<!-- login svelte -->

<script>
  import { navigate } from "svelte-routing";
  import { onMount } from 'svelte';
  import { login } from '../../Api.svelte';  // Api.svelte dosyasını import ediyoruz

  let uname = "";
  let password = "";
  let isLoading = false;
  let errorMessage = "";



  async function handleSubmit(event) {
    event.preventDefault(); // Formun otomatik olarak submit olmasını engeller
    isLoading = true; // fetch işlemi başladığında yükleniyor durumunu göster

    try {
      const rdata = await login(uname, password);
      // console.log(rdata);
      const token = rdata.data.token;
      const user = rdata.data.user.first_name;
      const uid = rdata.data.user._id;
      localStorage.setItem('token', token);
      localStorage.setItem('user', user);
      localStorage.setItem('uid', uid);
      navigate('/admin/dashboard'); // Yönlendirme yapmak için navigate fonksiyonunu 
    } catch (error) {
      errorMessage = error.message;
      // alertOpen = true;
    } finally {
      isLoading = false; // fetch işlemi tamamlandığında yükleniyor durumunu kapat
    }
  }

</script>

<div class="container mx-auto px-4 h-full">

  <div class="flex content-center items-center justify-center h-full">
    <div class="w-full lg:w-4/12 px-4">
      <div class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-200 border-0">
        <div class="flex-auto px-4 lg:px-10 py-10 pt-0">
          <div class="text-blueGray-400 text-center mb-3 font-bold">
            <img src="https://erdincyasar.uludag.edu.tr/yu.svg" alt="" class="mx-auto" width="200px;">
            <h3 class="text-blueGray-800">ARAŞTIRMA KAPASİTESİ BOYUTU GÖSTERGE TANIMLARI</h3>
          </div>
          <form on:submit={handleSubmit}>
            <div class="relative w-full mb-3">
              <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" for="grid-uname">
                Kullanıcı Adı
              </label>
              <input id="grid-uname" type="text" bind:value={uname} name="uname" 
              class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
              placeholder="Kullanıcı adınız"
              autocomplete="username"
              />
            </div>

            <div class="relative w-full mb-3">
              <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" for="grid-password">
                Password
              </label>
              <input id="grid-password" type="password" bind:value={password} name="password"  
              class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
              placeholder="Parolanız"
              autocomplete="current-password"
              />
            </div>

            <div class="text-center mt-6">
              <button class="bg-blueGray-800 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 w-full ease-linear transition-all duration-150" type="submit">
                {#if isLoading}
                  Yükleniyor...
                {:else}
                  Giriş
                {/if}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
